"use client";

export default function AITransform() {
  const cards = [
    {
      title: "Marketers & Content Creators",
    },
    {
      title: "Founders & Entrepreneurs",
    },
    {
      title: "Working Professionals",
    },
    {
      title: "Freelancers & Consultants",
      },
    {
      title: "Students & Job Seekers",
    },
  ];

  return (
    <section className="w-full py-6 md:py-12">
      <div className="w-[90%] md:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 text-left">
          <h2 className="text-[#041B01] text-[28px] md:text-[36px] font-medium mb-4 leading-tight">
           Who Is This Workshop For?
          </h2>
          <p className="text-[#041B01] text-base md:text-lg font-normal">
            Millions of business leaders, marketers, designers, and students use
            these AI tools and strategies to boost their performance and streamline
            their work.
          </p>
        </div>

        {/* Cards Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* First 3 cards */}
          {cards.slice(0, 3).map((card, index) => (
            <div
              key={index}
              className="flex items-center rounded-xl p-4 border border-[#818490] text-left"
              style={{ backgroundColor: "#FFFAF1" }}
            >
              {/* Star Icon - 4-pointed diamond */}
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-3 flex-shrink-0"
              >
                <polygon
                  points="12,2 22,12 12,22 2,12"
                  fill="#041B01"
                />
              </svg>
              <p className="text-[#041B01] text-base md:text-lg font-normal">
                {card.title}
              </p>
            </div>
          ))}
          {/* Last 2 cards - same width as first row */}
          <div className="flex flex-col md:flex-row md:col-span-3 gap-4">
            {cards.slice(3).map((card, index) => (
              <div
                key={index + 3}
                className="flex items-center rounded-xl p-4 border border-[#818490] text-left w-full md:flex-1"
                style={{ backgroundColor: "#FFFAF1" }}
              >
                {/* Star Icon - 4-pointed diamond */}
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-3 flex-shrink-0"
                >
                  <polygon
                    points="12,2 22,12 12,22 2,12"
                    fill="#041B01"
                  />
                </svg>
                <p className="text-[#041B01] text-base md:text-lg font-normal">
                  {card.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
